import styled from "styled-components"
import { PrimaryButton } from "../../buttons"
import { PureWrapper } from "../../wrappers"

export const ProfileSectionWrapper = styled(PureWrapper)`padding: 32px 24px`

export const FormButton = styled(PrimaryButton)`width: 175px`

export const InputWrapper = styled.div`width: 100%`

export const FormWrapper = styled.form`
  display: flex;
  gap: 32px;
  align-items: center;
  justify-content: space-between;
`

export const CodeWrapper = styled.div`
  padding: 8px 0 24px 0;
`
